import { gql } from '../../graphql/generated/gql';
import type { DocumentType } from '../../graphql/generated/gql';
import postPath from './postPath';

const THREAD_FRAGMENT = gql(`
  fragment commentThreadPath_thread on ThreadFields {
    id
    resolvedAt
    version
    post {
      ...postPath_post
    }
  }
`);

const commentThreadPath = (
  thread: DocumentType<typeof THREAD_FRAGMENT>,
  options: {
    isHistorical?: boolean;
  } = {},
) => {
  if (!thread.post) return undefined;
  const anchor = `thread-${thread.id}`;

  return postPath(thread.post, {
    histories:
      thread.resolvedAt || options.isHistorical
        ? `${thread.version}-${thread.version + 1}`
        : undefined,
    anchor,
  });
};

export default commentThreadPath;
